module.exports = __webpack_public_path__ + "static/media/calor.95cdedf9.png";